import { construction } from './construction'
import { exporting } from './export'
import { peIcon } from './pe-icon'
import { peLogo } from './pe-logo'
import { wand } from './wand'
import { zohoBooks } from './zoho-books'

export default {
  construction,
  exporting,
  peIcon,
  peLogo,
  wand,
  zohoBooks
}
